import { CommonModule, NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';
import { PromotionsListComponent } from './promotions-list.component';
import { PromotionCardComponent } from '../promotion-card/promotion-card.component';
import { ComponentsModule } from '../../components.module';
import { IonicModule } from '@ionic/angular';
import { ReactiveFormsModule } from '@angular/forms';
import { PromotionDetailPage } from '../promotion-detail/promotion-detail.component';
import { PromotionActionButtonsComponent } from '../promotion-action-buttons/promotion-action-buttons.component';

@NgModule({
  declarations: [PromotionsListComponent, PromotionCardComponent, PromotionDetailPage, PromotionActionButtonsComponent],
  imports: [
    NgOptimizedImage,
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule
  ],
  exports: [PromotionsListComponent, PromotionCardComponent, PromotionDetailPage, PromotionActionButtonsComponent]
})
export class PromotionsListModule { }
